import React, { useState, useEffect } from "react";
import { TextField, MenuItem, FormControlLabel, Checkbox } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { API } from "../../../App";

function PostContentRow(props) {
  const [content, setContent] = useState({});
  const subTableRowStyle = { fontSize: "1.7rem", color: "white" };

  const updatePost = (contentUpdate) => {
    return fetch(
      `${API}/api/admin/publications/${props.postId}/${content.id}/update-content`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
        body: JSON.stringify({ contentUpdate }),
      }
    );
  };

  const handleChange2 = async (event) => {
    const newValue = event.target.checked;
    updatePost({ active: event.target.checked })
      .then((res) => {
        setContent((x) => ({
          ...x,
          active: newValue,
        }));
      })
      .catch((err) => console.log(err.message));
  };

  const handleChange3 = async (event) => {
    const response = await updatePost({
      order: Number(event.target.value) - 1,
    }).catch((err) => console.log(err.message));
    if (response.status === 204) {
      setContent({
        ...content,
        order: Number(event.target.value) - 1,
      });
    }
  };

  useEffect(() => {
    setContent(props.c);
  }, []);

  return (
    <>
      <TableRow key={content.id}>
        <TableCell style={subTableRowStyle}>
          <Checkbox
            name={content.id}
            id={content.id}
            checked={content.active}
            onChange={handleChange2}
          />
        </TableCell>
        <TableCell style={subTableRowStyle}>
          {content.createdAt?.substring(0, 10)}
        </TableCell>
        <TableCell style={subTableRowStyle}>
          <img
            width="30%"
            height="30%"
            src={`/content/${content.path}`}
            srcSet={`/content/${content.path}`}
            alt={`/content/${content.path}`}
            loading="lazy"
          />
        </TableCell>

        <TableCell style={subTableRowStyle}>
          <select
            name="order"
            id="order"
            onChange={handleChange3}
            defaultValue={content.order + 1}
            className="form__select"
          >
            {Array(props.maxOrder)
              .fill()
              .map((_, index) => (
                <option key={index + 1} value={index + 1}>
                  {index + 1}
                </option>
              ))}
          </select>
          {/* {content.id} */}
        </TableCell>
      </TableRow>
    </>
  );
}

export default PostContentRow;
